"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeShippingCost = computeShippingCost;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const compute_shipping_price_1 = require("./compute-shipping-price");
const compute_cost_1 = require("../compute-cost");
const compute_line_price_from_fee_1 = require("../compute-line-price-from-fee");
function computeShippingCost(vatRate, shippingCostWithoutDiscount, shippingDiscount, lines) {
    const shippingPrice = (0, compute_shipping_price_1.computeShippingPrice)(shippingCostWithoutDiscount, shippingDiscount);
    return {
        totalCost: (0, compute_cost_1.computeCost)(vatRate, undefined, shippingPrice),
        costPerLine: (0, compute_line_price_from_fee_1.computeLinePriceFromFee)({ feesSpread: module_logistic_interfaces_1.FeesSpreadUnit.Quantity }, shippingPrice, lines).map(line => ({
            lineId: line.lineId,
            cost: (0, compute_cost_1.computeCost)(vatRate, undefined, line.retrocessionPrice)
        }))
    };
}
